// import { CaretLeft} from "@phosphor-icons/react";
// import React, { useState } from "react";
// import BubbleInput from "./component/BubbleInput";
// import { Link } from "react-router-dom";

// const EditProfil = () => {
//   const motto_hidup =
//     "Kalau lu mau berbuat baik ya buat baik aja keorang gausah mikirin apa kata orang lain, fokus aja sama orang orang yang support sama lo!";
//   const nama_user = "Farras Akhirio Ramadhan";
//   const nomor_telepon = 6283825102687;
//   const hobi = ["Gym", ""]; //INPUT ARRAY
//   const email = "farrasakra@gmail.com";
//   const kelas = "11 MIPA 2"; //Pendek
//   const reward = ["Juara 1 MPL Indonesia Tingkat Nasional", ""];
//   const mapel_favorit = ["Matematika", ""]; //INPUT ARRAY BIKIN BANYAK
//   const eskul = ["Pramuka", ""]; //INPUT ARRAY
//   const olahraga_favorit = "Gym";
//   const cita_cita = "Pengusaha";
//   const minatBakat = {
//     minat: "Pemrogramman",
//     bakat: "Bisa belajar otodidak",
//   };
//   const tubuh = {
//     tinggi_badan: 171,
//     berat_badan: 74,
//   };

//   const [formData, setFormData] = useState({
//     nama_user,
//     email,
//     nomor_telepon,
//     kelas,
//     motto_hidup,
//     cita_cita,
//     minat: minatBakat.minat,
//     bakat: minatBakat.bakat,
//     hobi,
//     kemampuan: [
//       "Web Development",
//       "Editing",
//       "Public Speaking",
//       "Management Risk",
//       "Lift Heavy Weight", ""
//     ],
//     eskul,
//     mapel_favorit,
//     berat_badan: tubuh.berat_badan,
//     tinggi_badan: tubuh.tinggi_badan,
//     olahraga_favorit,
//     reward,
//   });

//   // Handler untuk menangani perubahan input
//   const handleChangeString = (e) => {
//     const { name, value } = e.target;

//     // Perbarui nilai state berdasarkan nama input
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };
//   const handleChangeArray = (e, index) => {
//     const { name, value } = e.target;

//     setFormData((prevData) => {
//       const updatedArray = [...(prevData[name] || [])];
//       updatedArray[index] = value; // Perbarui nilai pada index tertentu

//       // Tambahkan input kosong jika elemen terakhir sudah tidak kosong
//       if (updatedArray[updatedArray.length - 1] !== "") {
//         updatedArray.push("");
//       }

//       return {
//         ...prevData,
//         [name]: updatedArray,
//       };
//     });
//   };

//   const handleRemoveArray = (name, index) => {
//     setFormData((prevData) => {
//       const updatedArray = [...(prevData[name] || [])];
//       updatedArray.splice(index, 1); // Hapus elemen pada indeks tertentu

//       return {
//         ...prevData,
//         [name]: updatedArray,
//       };
//     });
//   };

//   return (
//     <div className="relative min-h-svh bg-slate-100 flex flex-col gap-8 px-4 pt-6 pb-28">
//       <div className="flex justify-between">
//         <Link to={"/settings"}>
//           <CaretLeft size={26} />
//         </Link>
//         <p className="text-lg font-bold">Edit Profile</p>
//         <div></div>
//       </div>
//       <div className="flex flex-col gap-4">
//         {Object.keys(formData).map((cb, i) => {
//           const newWords = cb.split("_").join(" ");
//           if (i === 6 || i === 12) {
//             return (
//               <div className="grid grid-cols-2 gap-2" key={i}>
//                 <div className="flex flex-col gap-2">
//                   <p className="text-md font-semibold capitalize">{newWords}</p>
//                   <input
//                     type="text"
//                     value={formData[cb]}
//                     name={cb}
//                     onChange={handleChangeString}
//                     className="bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400"
//                   />
//                 </div>
//                 <div className="flex flex-col gap-2">
//                   <p className="text-md font-semibold capitalize">
//                     {Object.keys(formData)[i + 1].split("_").join(" ")}
//                   </p>
//                   <input
//                     type="text"
//                     name={Object.keys(formData)[i + 1]}
//                     onChange={handleChangeString}
//                     value={formData[Object.keys(formData)[i + 1]]}
//                     className="bg-gray-200 h-10 px-4  border font-normal text-xs rounded-lg border-gray-400"
//                   />
//                 </div>
//               </div>
//             );
//           } else if (typeof formData[cb] === "string") {
//             return (
//               <div className="flex flex-col gap-2">
//                 <p className="text-md font-semibold capitalize">{newWords}</p>
//                 <input
//                   value={formData[cb]}
//                   name={cb}
//                   onChange={handleChangeString}
//                   type={cb === "email" ? "email" : "text"}
//                   className="bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400"
//                 />
//               </div>
//             );
//           }else if (Array.isArray(formData[cb])) {
//             return (
//               <div className="flex flex-col gap-2">
//                 <p className="text-md font-semibold capitalize">{newWords}</p>
//                 <div className="flex gap-3 flex-wrap">
//                   {formData[cb].map((ok, a) => (
//                     <BubbleInput
//                       key={a}
//                       index={a}
//                       name={cb}
//                       val={ok}
//                       handleChangeArray={handleChangeArray}
//                       handleRemoveArray={handleRemoveArray}
//                     />
//                   ))}
//                 </div>
//               </div>
//             );
//           }

//         })}
//       </div>
//       <div className="flex justify-end">
//         <div className="bg-green-700 py-2 text-md rounded-xl px-3 cursor-pointer font-semibold text-white">
//             Update
//         </div>
//       </div>
//     </div>
//   );
// };

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";
import { jwtDecode } from "jwt-decode";
import { useCookies } from "react-cookie";
import axios from "axios";
import { toast } from "sonner";

const EditProfil = () => {
  const routerPush = useNavigate();

  const handleClick = () => {
    routerPush("/");
  };

  const handlePrev = () => {
    routerPush("/settings");
  };

  const [formData, setFormData] = useState({});
  const [namaGweh, setNamaGweh] = useState(null);
  const [cookies] = useCookies(["token"]);
  const navigate = useNavigate();

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (
      !cookies.token ||
      cookies.token === null ||
      cookies.token === undefined
    ) {
      navigate("/login");
    } else {
      try {
        // Pastikan cookies.token adalah string dan valid
        const token = cookies.token;
        if (typeof token === "string" && token) {
          const emailGweh = jwtDecode(token).email;
          setNamaGweh(emailGweh);
        } else {
          navigate("/login");
          throw new Error("Invalid token format");
        }
      } catch (error) {
        console.log("MASUK SINI 3");

        navigate("/login");
        console.error("Invalid tokenmm", error);
      }
    }
  }, [cookies.token, navigate]); // Menambahkan dependencies

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (namaGweh !== null) {
      const response = fetch(`${process.env.REACT_APP_SERVER}/api/user/${namaGweh}`)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
          const thisUser = data.payload.datas;

          setFormData({
            nama_lengkap: thisUser.name,
            email: thisUser.email,
            nomor_telepon: thisUser.no_tel,
            bagian: thisUser.bagian,
            posisi: thisUser.posisi,
          });
        })
        .catch((error) => setError(`An error occurred: ${error}`))
        .finally(() => setLoading(false));
    }
  }, [namaGweh]);

  if (loading) return <div></div>;
  else if (error) return <div>Error Bos: {error}</div>;

  // Handler untuk menangani perubahan input
  const handleChangeString = (e) => {
    const { name, value } = e.target;

    // Perbarui nilai state berdasarkan nama input
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const responseAttend = await axios.put(
        `${process.env.REACT_APP_SERVER}/api/update-profile`,
        {
          id: data.payload.datas.id,
          name: formData.nama_lengkap,
          no_tel: formData.nomor_telepon,
          bagian: formData.bagian,
          posisi: formData.posisi,
        }
      );
      console.log("🚀 ~ handleUpdate ~ responseAttend:", responseAttend);
      toast.success("Update User Request successfully created!");
      handleClick();
    } catch (error) {
      console.error("Error update data:", error);
      toast.error("Error update data." + error);
    }
  };
  return (
    <form
      onSubmit={handleUpdate}
      className="relative min-h-svh bg-slate-100 w-full flex flex-col gap-8  px-4 pt-6 pb-28"
    >
      <p className="text-lg font-bold text-center">Edit Profile</p>
      <div className="absolute cursor-pointer text-black " onClick={handlePrev}>
        <CaretLeft size={24} weight="bold" />
      </div>
      <div className="flex flex-col gap-4">
        {Object.keys(formData).map((cb, i) => {
          const newWords = cb.split("_").join(" ");
          if (i === 3 || i === 4) {
            return (
              <div className="flex flex-col gap-2" key={i}>
                <p className="text-md font-semibold capitalize">{newWords}</p>
                <select
                  value={formData[cb]}
                  name={cb}
                  onChange={handleChangeString}
                  className="bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400"
                >
                  {i === 4 ? (
                    <>
                      <option value="Karyawan">Karyawan</option>
                      <option value="Magang">Magang</option>
                    </>
                  ) : (
                    <>
                      <option value="News">News</option>
                      <option value="Produksi">Produksi</option>
                    </>
                  )}
                </select>
              </div>
            );
          } else {
            return (
              <div className="flex flex-col gap-2" key={i}>
                <p className="text-md font-semibold capitalize">{newWords}</p>
                <input
                  value={formData[cb]}
                  name={cb}
                  onChange={handleChangeString}
                  disabled={cb === "email"}
                  type={
                    cb === "email"
                      ? "email"
                      : cb === "nomor_telepon"
                      ? "number"
                      : "text"
                  }
                  className={
                    cb === "email"
                      ? "cursor-not-allowed text-gray-600 bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400"
                      : "bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400"
                  }
                />
              </div>
            );
          }
        })}
      </div>
      <div className="flex justify-end absolute bottom-0 right-0 mb-20  me-4">
        <button
          type="submit"
          className="bg-green-700 py-2 text-md rounded-xl px-3 cursor-pointer font-semibold text-white"
        >
          Update
        </button>
      </div>
    </form>
  );
};

export default EditProfil;
